import { MarketSpec } from '@/store/use-markets-store';
import { FilledOrder } from '@/store/use-orders-store';
import { OrderType } from '@/types';
import { abbrFromSym } from '@/utils/token-symbol';
import { bigIntToDecimalStr } from '@/utils/value-format';
import { toast } from 'sonner';

export default function toastFilledOrder(
  order: FilledOrder,
  marketSpec: MarketSpec,
) {
  const symAbbr = abbrFromSym(order.symbol);
  const lastFilledSizeStr = bigIntToDecimalStr(
    order.lastFilledSize,
    marketSpec.sizeDecimals,
  );
  const lastFilledPriceStr = bigIntToDecimalStr(
    order.lastFilledPrice,
    marketSpec.priceDecimals,
  );

  // Display background notifications
  if (order.orderType === OrderType.LIQUIDATION) {
    toast.success(
      `Liquidated ${lastFilledSizeStr} ${symAbbr} at ${lastFilledPriceStr}.`,
    );
  } else if (order.orderType === OrderType.LIMIT) {
    toast.success(
      <span>
        {order.isBuy ? 'Long' : 'Short'} {lastFilledSizeStr} {symAbbr} filled at{' '}
        {lastFilledPriceStr}.
        <br className="lg:hidden" />
        <span className="lg:hidden">
          See{' '}
          <button
            className="font-medium underline"
            onClick={() => {
              const navigate = new CustomEvent('app:navigate', {
                detail: { pathname: '/portfolio' },
              });
              window.dispatchEvent(navigate);
            }}
          >
            Positions
          </button>
        </span>
      </span>,
    );
  } else if (order.orderType === OrderType.TAKE_PROFIT) {
    toast.success(
      `Take profit ${lastFilledSizeStr} ${symAbbr} filled at ${lastFilledPriceStr}.`,
    );
  } else if (order.orderType === OrderType.STOP_LOSS) {
    toast.success(
      `Stop loss ${lastFilledSizeStr} ${symAbbr} filled at ${lastFilledPriceStr}.`,
    );
  }
}
